import {Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {CustomerServicePriceOverride} from '../../../@core/models/customer/CustomerServicePriceOverride';
import {WarehouseServiceService} from '../../../@core/services/megalog/warehouse-service.service';
import {WarehouseServiceModel} from '../../../@core/models/megalog/WarehouseService';
import {Observable, of} from 'rxjs';
import {ConfirmComponent} from '../../base/confirm/confirm.component';
import {NbDialogService} from '@nebular/theme';

@Component({
  selector: 'ngx-user-service-price-overrides',
  templateUrl: './user-service-price-overrides.component.html',
  styleUrls: ['./user-service-price-overrides.component.scss'],
})
export class UserServicePriceOverridesComponent implements OnInit, OnChanges {

  @Input()
  public priceOverrides: CustomerServicePriceOverride[] = [];
  @Input()
  public disabled: boolean = false;

  public services: WarehouseServiceModel[] = [];
  public displayServices: WarehouseServiceModel[] = [];
  public filteredDisplayServices$: Observable<WarehouseServiceModel[]>;

  constructor(
    private warehouseService: WarehouseServiceService,
    private dialogService: NbDialogService
  ) { }

  async ngOnInit(): Promise<void> {
    this.services = await this.warehouseService.getAll();
    this.updateAvailableServices();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if(changes.priceOverrides) {
      if(!Array.isArray(this.priceOverrides)) {
        this.priceOverrides = [];
      }
      this.updateAvailableServices();
    }
  }

  public addEntry(): void {
    this.priceOverrides.push(new CustomerServicePriceOverride());
  }

  public getServiceNameBySelected(override: CustomerServicePriceOverride): string {
    if (override == undefined) return '';
    let a = this.services.find(x => x.id == override.serviceId);
    if (a != undefined) return a.name;
    return '';
  }

  public filterSelectOptions(value: string) {
    this.filteredDisplayServices$ = of(this.filterServices(value));
  }

  private filterServices(value: string): WarehouseServiceModel[] {
    if (value != undefined) {
      let filterValue;
      if (typeof value == 'string') {
        filterValue = value.toLowerCase();
      } else {
        filterValue = value;
      }
      return this.displayServices.filter(a => a.name.toLowerCase().includes(filterValue));
    } else {
      return [];
    }
  }

  public serviceSelectedChange(serviceId: string, override: CustomerServicePriceOverride): void {
    if (this.services.find(x => x.id == serviceId) != undefined) {
      override.serviceId = serviceId;
      this.updateAvailableServices();
    }
  }

  public delete(index: number): void{

    const modal = this.dialogService.open(ConfirmComponent,
      {
        context: {
          deactivate: false,
        },
      });
    modal.onClose.subscribe({
      next: response => {
        if (response !== undefined && response.delete) {
          this.priceOverrides.splice(index, 1);
          this.updateAvailableServices();
        }
      },
    });
  }

  private updateAvailableServices(): void {
    let tmp: WarehouseServiceModel[] = Object.assign([], this.services);
    for(let o of this.priceOverrides) {
      if(tmp.find(x => x.id == o.serviceId) != undefined) {
        tmp.splice(tmp.indexOf(tmp.find(x => x.id == o.serviceId)), 1);
      }
    }
    this.displayServices = tmp;
  }

}
